class ProductGrid extends HTMLElement {
    constructor() {
        super();

        this.querySelectorAll('.product-grid-button').forEach((button) => {
            button.addEventListener('click', () => this.onButtonClick(button.getAttribute('data-index')))
        });
    }

    onButtonClick = (index) => {
        this.querySelectorAll('.product-grid-img').forEach((img) => {
            img.style.display = 'none';
        });

        this.querySelectorAll('.product-grid-img').forEach((img) => {
            if(img.getAttribute('data-index') == index) {
                img.style.display = 'block';
            }
        });

        this.querySelectorAll('.product-grid-button').forEach((button) => {
            button.classList.remove('product-grid-button-active');

            if(button.getAttribute('data-index') == index) {
                button.classList.add('product-grid-button-active');
            }
        });
    }
}

customElements.define('product-grid-component', ProductGrid);